import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../login/auth.service';
import {
  Eshop,
  EshopCreateDto,
  EshopCreateLinkDto,
  EshopLink,
  EshopLinkToProductDto,
  EshopSearchDto,
  EshopSearchLinksDto,
  EshopUpdateDto,
  EshopUpdateLinkDto
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class EshopService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  create(payload: EshopCreateDto) {
    return this.http.post<Eshop>(`${environment.BACKEND}/eshop/create`, payload);
  }

  update(payload: EshopUpdateDto) {
    return this.http.put(`${environment.BACKEND}/eshop/update`, payload);
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/eshop/${id}`);
  }

  search(payload?: EshopSearchDto) {
    return this.http.post<{ data: Eshop[]; length: number }>(
      `${environment.BACKEND}/eshop/search`,
      payload
    );
  }

  getOne(id: number) {
    return this.http.get(`${environment.BACKEND}/eshop/${id}`);
  }

  createLink(payload: EshopCreateLinkDto) {
    return this.http.post<EshopLink>(`${environment.BACKEND}/eshop/create_link`, payload);
  }

  updateLink(payload: EshopUpdateLinkDto) {
    return this.http.put(`${environment.BACKEND}/eshop/update_link`, payload);
  }

  deleteLink(id: number) {
    return this.http.delete(`${environment.BACKEND}/eshop/link/${id}`);
  }

  getOneLink(id: number) {
    return this.http.get(`${environment.BACKEND}/eshop/link/${id}`);
  }

  searchLinks(payload: EshopSearchLinksDto) {
    return this.http.post<{ length: number; data: EshopLink[] }>(
      `${environment.BACKEND}/eshop/search_links`,
      payload
    );
  }

  linkToProduct(payload: EshopLinkToProductDto) {
    return this.http.put(`${environment.BACKEND}/eshop/link_to_product`, payload);
  }
}
